import React from 'react';
import { useLocation } from 'react-router-dom';
import CompanyDisclosure from './CompanyDisclosure';

/** Public pages that already render CompanyDisclosure in their own footer. */
const PAGES_WITH_DISCLOSURE = new Set([
  '/',
  '/book-demo',
  '/homepage-legacy',
  '/dental-consent-forms',
  '/dental-consent-plans',
  '/dental-compliance-software',
  '/digital-consent-dentists',
  '/dental-practice-management',
  '/dental-templates',
  '/cpd-legal-consent',
  '/terms',
  '/privacy',
  '/privacy-policy',
  '/contact',
]);

function hasOwnDisclosure(pathname) {
  if (PAGES_WITH_DISCLOSURE.has(pathname)) return true;
  if (pathname.startsWith('/clinic') || pathname.startsWith('/admin') || pathname.startsWith('/setup')) {
    return true;
  }
  return false;
}

/** Footer for public pages that do not already show the company registration line. */
export default function SiteCompanyNotice() {
  const { pathname } = useLocation();
  if (hasOwnDisclosure(pathname)) return null;

  return (
    <footer className="border-t border-gray-200 bg-white">
      <div className="max-w-5xl mx-auto px-4 py-6 text-center">
        <CompanyDisclosure tone="light" />
      </div>
    </footer>
  );
}
